import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

const LOGO_URL = '/logo-givinghopes.png';

export default function Register() {
  const [formData, setFormData] = useState({ email: '', password: '', name: '', role: 'parent' });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await register(formData.email, formData.password, formData.name, formData.role);
    setLoading(false);
    if (result.success) {
      toast.success('Account created!');
      navigate('/dashboard');
    } else {
      toast.error(result.error);
    }
  };

  return (
    <div className="min-h-screen pt-16 flex items-center justify-center px-6 py-12 bg-[var(--bg-alt)]" data-testid="register-page">
      <div className="max-w-md w-full card-elevated p-8">
        <div className="flex items-center gap-3 mb-8">
          <img src={LOGO_URL} alt="Giving Hope" className="h-10 w-10 object-contain" />
          <span className="text-lg font-heading font-bold text-[var(--text-headline)]">
            Giving Hope <span className="text-[var(--primary-blue)]">LLC</span>
          </span>
        </div>

        <h2 className="text-3xl font-heading font-bold mb-2">Get Started</h2>
        <p className="text-[var(--text-body)] mb-8">Create your account</p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="name" className="block text-sm font-semibold mb-1.5 text-[var(--text-headline)]">Full Name</label>
            <input id="name" name="name" type="text" value={formData.name} onChange={handleChange} required
              className="w-full px-4 py-3 rounded-xl border border-[var(--border-color)] bg-[var(--bg-alt)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-blue)] text-sm"
              placeholder="John Doe" data-testid="register-name-input" />
          </div>
          <div>
            <label htmlFor="email" className="block text-sm font-semibold mb-1.5 text-[var(--text-headline)]">Email</label>
            <input id="email" name="email" type="email" value={formData.email} onChange={handleChange} required
              className="w-full px-4 py-3 rounded-xl border border-[var(--border-color)] bg-[var(--bg-alt)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-blue)] text-sm"
              placeholder="you@example.com" data-testid="register-email-input" />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-semibold mb-1.5 text-[var(--text-headline)]">Password</label>
            <input id="password" name="password" type="password" value={formData.password} onChange={handleChange} required minLength={6}
              className="w-full px-4 py-3 rounded-xl border border-[var(--border-color)] bg-[var(--bg-alt)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-blue)] text-sm"
              placeholder="Min 6 characters" data-testid="register-password-input" />
          </div>
          <div>
            <label htmlFor="role" className="block text-sm font-semibold mb-1.5 text-[var(--text-headline)]">I am a...</label>
            <select id="role" name="role" value={formData.role} onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl border border-[var(--border-color)] bg-[var(--bg-alt)] focus:outline-none focus:ring-2 focus:ring-[var(--primary-blue)] text-sm"
              data-testid="register-role-select">
              <option value="parent">Parent / Guardian</option>
              <option value="clinician">Clinician / Trainee</option>
            </select>
          </div>
          <button type="submit" disabled={loading} className="w-full btn-primary disabled:opacity-50" data-testid="register-submit-btn">
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-[var(--text-body)]">
          Already have an account?{' '}
          <Link to="/login" className="text-[var(--primary-blue)] font-semibold hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
